//
//
//
//
//
//
//
//
//
//
//
//

import { cap36 } from "@/config";
import { getBizType } from "@/js/utils";
import { CLEAR_PLAN_TYPE_LIST } from "@/config";

export default {
    name: 'earlySettleChargeRule',
    props: {
        value: Boolean,
        repayInitData: {
            type: Object,
        },
    },
    data() {
        return {
            show: this.value,
        }
    },
    watch: {
        show() {
            this.$emit('input', this.show)
        },
        value() {
            this.show = this.value
        },
    },
    computed: {
        isLoan() {
            return getBizType() == "Loan";
        },
        hasClearPlanType() {
            const { clearPlanType } = this.repayInitData;
            return CLEAR_PLAN_TYPE_LIST.includes(clearPlanType);
        },
    },
    methods: {
        closeDialog() {
            this.$emit('input', false)
        },
        getRuleContent() {
            const { clearPlanType, preClearplanType, capDailyRate } = this.repayInitData;

            const content = {
                8: "flexibleRepay",
                5: "preSettleDaily",
            };

            if ([8, 5].includes(preClearplanType)) {
                return preClearplanType == 8 ? cap36[content[preClearplanType]].replace('capDailyRate', capDailyRate) : cap36[content[preClearplanType]];
            }

            const planType =
                this.hasClearPlanType && this.isLoan
                    ? clearPlanType
                    : "Default";
            return cap36[planType];
        },
        getContainer() {
            return document.querySelector('.app-container');
        },
    }
}
